export default "<div class=\"name\"><%- firstname %> <%- lastname %></div>\n<div class=\"view\">View</div>\n";